
import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";
import PIcon from "@/common/components/look/PIcon/PIcon.vue";

@Component({
  components: { PIcon },
})
export class PFormInputTextSearch extends Vue {
  @Prop({ required: true }) value!: string;

  @Watch("value", { immediate: true })
  onChangeValue(): void {
    this.valueLocal = typeof this.value === "string" ? this.value : "";
  }

  @Prop({ required: false, default: "" }) placeholder!: string;
  @Prop({ required: false, default: "" }) label!: string;
  @Prop({ required: false, default: false }) readonly!: boolean;
  @Prop({ required: false, default: true }) show!: boolean;

  @Ref("inputRef") readonly inputRef!: HTMLInputElement;

  valueLocal = "";
  showInput = false;

  mounted(): void {
    this.showInput = this.show;
  }

  get classComp(): string {
    return (this.valueLocal ?? "").trim() !== ""
      ? "search_PFormInputTextSearch active_PFormInputTextSearch"
      : "search_PFormInputTextSearch";
  }

  input(): void {
    const clean = (this.valueLocal ?? "").trim();
    this.$emit("input", clean);
    this.$emit("change", clean);
  }

  click(): void {
    this.showInput = true;
    this.$nextTick(() => {
      if (this.inputRef && typeof this.inputRef.focus === "function") {
        this.inputRef.focus();
      }
    });
  }

  mouseleave(): void {
    if (this.valueLocal === "" && !this.show) {
      this.showInput = false;
    }
  }
}
export default PFormInputTextSearch;
